export default __webpack_public_path__ + "static/media/Checkbox.c5a31016.png";